<!-- eslint-disable-next-line vue/no-reserved-component-names -->
<template>
    <div class="chartAreaWrapper">
        <LineChart :chart-id="chartId" :dataset-id-key="datasetIdKey" :chart-options="chartOptions" :chart-data="chartData"
            :width="width" :height="height" />
    </div>
</template>

<script>
import { Line as LineChart } from "vue-chartjs";
import zoom from "chartjs-plugin-zoom";
import { Chart as ChartJS, Title, Tooltip, CategoryScale, LinearScale, PointElement, LineElement } from "chart.js"

ChartJS.register(Title, Tooltip, CategoryScale, LinearScale, PointElement, LineElement, zoom);

export default {
    name: "AreaChart",
    components: {
        LineChart
    },
    props: {
        data: {
            required: true,
            type: Array
        },
        labels: {
            required: true,
            type: Array
        },
        chartId: {
            type: String,
            default: "area-chart"
        },
        datasetIdKey: {
            type: String,
            default: "label"
        },
        width: {
            type: Number,
            default: 600
        },
        height: {
            type: Number,
            default: 600
        },
        cssClasses: {
            default: "",
            type: String
        }
    },
    data() {
        return {
            verticalLineData: [],
            chartData: {
                labels: this.labels,
                datasets: [{
                    label: "",
                    borderWidth: 2,
                    data: this.data,
                    fill: true,
                    borderColor: "#0088AA",
                    backgroundColor: "#0088AA",
                    tension: 0.5,
                    yAxisID: 'y'
                }]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },                    
                    zoom: {
                        zoom: {
                            wheel: {
                                enabled: true,
                            },
                            pinch: {
                                enabled: true
                            },
                            mode: 'xy',
                        },
                        pan: {
                            enabled: true,
                            mode: 'xy'
                        }
                    }
                }               
            }
        }
    },
    watch: {
        data: function (newData) {
            this.chartData.datasets[0].data = newData;
        },
        labels: function (newData) {
            this.chartData.labels = newData;
        }
    },
    methods: {
        verticalLineMove(event) {
            // clientX/Y gives the coordinates relative to the viewport in CSS pixels.

            // pageX/Y gives the coordinates relative to the <html> element in CSS pixels.
            const dotted = [];
            dotted.push(0); dotted.push(event.pageY);
            this.chartData.datasets[1].data = dotted;
        }
    }
}
</script>

<style scoped>

.chartAreaWrapper {
    width: 100%;
    height: auto;
    overflow-x: scroll;
}

</style>
